import BidHistoryModal from './bidHistoryModal'

export default BidHistoryModal
